// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"6368181a","453":"161178da","455":"e7842c48","977":"cd31ce9f"}[chunkId] + ".chunk.js";
};